$(document).ready(function(){

	var cookiesVal = Cookies.get('cookies');
	var cookiesAlertVal = Cookies.get('cookiesAlert');
	if (cookiesAlertVal !== 'false') {
		showCookies();
	} else {
		hideCookies();
	}
	
	if (cookiesVal == 'allow') {
		var trackingID = $('meta[name=ga]').attr('content');
		if (typeof(trackingID) !== 'undefined') {
			var trackingCode = '<!-- Global site tag (gtag.js) - Google Analytics --><script async src="https://www.googletagmanager.com/gtag/js?id='+ trackingID +'"></script><script>window.dataLayer=window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag("js", new Date()); gtag("config", "'+ trackingID +'");</script>';
			$('body').append(trackingCode);
		}
	}


	$('.close__cookies').on('click', function(){
		hideCookies();
		Cookies.set('cookiesAlert','false',{expires: 30});
	});

	$('button[name="decline__cookies"]').on('click', function(){
		Cookies.set('cookies','decline',{expires: 30});
	});

	$('button[name="allow__cookies"]').on('click', function(){
		Cookies.set('cookies','allow',{expires: 30});
	});


	function setCookiesA11y(isVisible){
		var $wrapper = $('.cookies__wrapper');
		var $focusables = $wrapper.find('button, a, input, select, textarea');
		if (isVisible) {
			$wrapper.attr('aria-hidden', 'false').removeAttr('inert');
			$focusables.removeAttr('tabindex');
		} else {
			$wrapper.attr('aria-hidden', 'true').attr('inert', '');
			$focusables.attr('tabindex', '-1');
		}
	}

	function showCookies(){
		setCookiesA11y(true);
		$('.cookies__wrapper').animate({
			'bottom': 0,
		},'fast');
	}

	function hideCookies(){
		setCookiesA11y(false);
		$('.cookies__wrapper').animate({
			'bottom': -155,
		},'fast');
	}
	
});
